var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloseRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-240 -391) translate(48 279) translate(0 112) translate(192)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed5465",
    d: "M18.784 16.696L14.087 12l4.697-4.696c.288-.289.288-.756 0-1.044L17.74 5.216c-.288-.288-.755-.288-1.044 0L12 9.913 7.304 5.216c-.289-.288-.756-.288-1.044 0L5.216 6.26c-.288.288-.288.755 0 1.044L9.913 12l-4.697 4.696c-.288.289-.288.756 0 1.044l1.044 1.044c.288.288.755.288 1.044 0L12 14.087l4.696 4.697c.289.288.756.288 1.044 0l1.044-1.044c.288-.288.288-.755 0-1.044z",
    transform: "translate(-240 -391) translate(48 279) translate(0 112) translate(192)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseRed);
export default __webpack_public_path__ + "static/media/icon-close-red.becbc906.svg";
export { ForwardRef as ReactComponent };